import {
    BANKMASTERVIEW_SUCCESS,
    BANKMASTERVIEW_FAILED,
    RESET_BANKMASTERVIEW,
    LOADING_BANKMASTERVIEW,
    BANKMASTERVIEW_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKMASTERVIEW:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKMASTERVIEW_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKMASTERVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BANKMASTERVIEW_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKMASTERVIEW:
            return (state = initialState);
        default:
            return state;
    }
};
